const media = (el) => {
    const activateButton = el
    const body = document.querySelector('body')
    const id = el.getAttribute('data-trigger-id')
    const videoContainer = el.parentElement.querySelector('div.video--container[data-id="' + id + '"]')
    const video = videoContainer.querySelector('video')
    const backgroundClose = videoContainer.querySelector('div.videoCloseBackground')
    const buttonClose = videoContainer.querySelector('button#videoClose')
    const focusTrap = videoContainer.querySelector('div#focusTrap')

    body.style.overflow = 'hidden'
    videoContainer.classList.add('active')
    buttonClose.setAttribute('tabindex', '0')
    video.setAttribute('tabindex', '0')
    focusTrap.setAttribute('tabindex', '0')
    activateButton.setAttribute('aria-expanded', 'true')
    videoContainer.removeAttribute('hidden')
    video.currentTime = 0
    video.play()
    buttonClose.focus();

    // Tab-Trap in VideoContainer
    videoContainer.addEventListener("keydown", (event) => {
        const focusableElements = [buttonClose, video, focusTrap]; // Reihenfolge: Button → Video
        const currentIndex = focusableElements.indexOf(document.activeElement);
    
        if (event.key === "Tab") {
            if (event.shiftKey) {
                // Rückwärts durch die Elemente
                if (currentIndex === 0) {
                    event.preventDefault();
                    focusableElements[focusableElements.length - 1].focus();
                }
            } else {
                // Vorwärts durch die Elemente
                if (currentIndex === focusableElements.length - 1) {
                    event.preventDefault();
                    focusableElements[0].focus();
                }
            }
        }

        focusTrap.addEventListener("focus", () => {
            buttonClose.focus();
        });
    });
    
    
    buttonClose.addEventListener('click', () => {
        mediaClose()
    })
    backgroundClose.addEventListener('click', () => {
        mediaClose()
    })

    el.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' || event.key === ' ') {
            event.preventDefault(); // Verhindert Scrollen bei Leertaste
            mediaClose(el)
        }
    });

    videoContainer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' || event.key === ' ') {
            event.preventDefault(); // Verhindert Scrollen bei Leertaste
            mediaClose(el)
        }
    });

    const mediaClose = (el) => {
        body.style.overflow = ''
        videoContainer.classList.remove('active')
        buttonClose.setAttribute('tabindex', '-1')
        video.setAttribute('tabindex', '-1')
        focusTrap.setAttribute('tabindex', '-1')
        activateButton.setAttribute('aria-expanded', 'false')
        videoContainer.setAttribute('hidden', '')
        video.pause()
        activateButton.focus()
    }
}

document.querySelectorAll('figure.video--thumbnail--container').forEach(thumbnail => {
    thumbnail.addEventListener('click', () => {
        media(thumbnail)
    })
    thumbnail.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Verhindert Scrollen bei Leertaste
            media(thumbnail)
        }
    });
})

document.querySelectorAll('button.video--button').forEach(button => {
    button.addEventListener('click', () => {
        media(button)
    })
})